export const name = 'ABST.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    // @ts-ignore
    return [<div class={[`${column.property}-cell`]} domPropsInnerHTML={row[column.property]}/>];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
